namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_select extends $.$shm_hitalama_map_widget_float_table_select {
		height_max() { return super.height_max() / this.Follower().zoom() }
	}
}
